export enum GSMServiceKind {
  GAS = "GAS",
  HQM = "HQM",
  HTD = "HTD",
  HTZ = "HTZ",
  KHS = "KHS",
  RLT = "RLT",
  UNDEFINED = "UNDEFINED",
  SHS = "SHS",
  TWH = "TWH",
  VBS = "VBS",
  VDK = "VDK",
  WRH = "WRH",
}

export const ServiceKindList: GSMServiceKind[] = [
  GSMServiceKind.HTZ,
  GSMServiceKind.RLT,
  GSMServiceKind.SHS,
  GSMServiceKind.VBS,
  GSMServiceKind.WRH,
  GSMServiceKind.HTD,
  GSMServiceKind.KHS,
  GSMServiceKind.TWH,
  GSMServiceKind.VDK,
  GSMServiceKind.GAS,
  GSMServiceKind.HQM,
];

/**
 * ProcessServiceKinds are the service kinds a process may be scoped to;
 * a process without one is an omni process. Mirrors
 * `process.ServiceKinds`, backend/core/processes/domain/process/service_kinds.go.
 */
export const ProcessServiceKinds: GSMServiceKind[] = [
  GSMServiceKind.HTZ,
  GSMServiceKind.RLT,
  GSMServiceKind.VBS,
  GSMServiceKind.WRH,
];

/**
 * WorkOrderServiceKinds are the service kinds with work orders, the ones
 * commitments and the work order dashboard deal with.
 */
export const WorkOrderServiceKinds: GSMServiceKind[] = [
  GSMServiceKind.HTZ,
  GSMServiceKind.RLT,
  GSMServiceKind.VBS,
];

export function parseServiceKind(str: string): GSMServiceKind | undefined {
  switch (str.toLowerCase()) {
    case "htz":
      return GSMServiceKind.HTZ;
    case "rlt":
      return GSMServiceKind.RLT;
    case "shs":
      return GSMServiceKind.SHS;
    case "vbs":
      return GSMServiceKind.VBS;
    case "wrh":
      return GSMServiceKind.WRH;
    case "htd":
      return GSMServiceKind.HTD;
    case "khs":
      return GSMServiceKind.KHS;
    case "twh":
      return GSMServiceKind.TWH;
    case "vdk":
      return GSMServiceKind.VDK;
    case "gas":
      return GSMServiceKind.GAS;
    case "hqm":
      return GSMServiceKind.HQM;
    default:
      return GSMServiceKind.UNDEFINED;
  }
}

/** Mirrors `service.Kind.German`, backend/core/services/domain/service/kind.go. */
export function serviceKindLabel(kind: string): string {
  switch (kind) {
    case GSMServiceKind.VBS:
      return "Vorbeugender Brandschutz";
    case GSMServiceKind.RLT:
      return "Raumlufttechnik";
    case GSMServiceKind.HTZ:
      return "Hygiene Technischer Zustand";
    case GSMServiceKind.SHS:
      return "Sanitär Hygiene Service";
    case GSMServiceKind.WRH:
      return "Waschraum Hygiene";
    case GSMServiceKind.KHS:
      return "Küchen-Hygiene Service";
    case GSMServiceKind.TWH:
      return "Trinkwasserhygiene";
    case GSMServiceKind.VDK:
      return "Verdunstungskühlanlagen";
    case GSMServiceKind.HTD:
      return "Hygienisch-Technische Dienstleistung";
    case GSMServiceKind.GAS:
      return "Aeroseal";
    case GSMServiceKind.HQM:
      return "Hygiene Qualitäts-Management";
    default:
      return kind;
  }
}
